import { getStaticOption } from '../../../core/forms/helpers/getStaticOption';
import { id } from 'inversify';
import { IDs } from '../../../helpers/IDs';
import * as Moment from 'moment';
import { StructureTool } from '../../../core/forms/helpers/structure_tool';

// Die Datensätze haben alle ähnliche Felder... wir prüfen was da ist und zeigen das an, so dass für alle Energiedaten etwas angezeigt wird
export function renderDatensatzForSelect(row: any, bundle: any, formConfig: any, entity: any, list: any[]) {

    // Bugfix: renderDatensatzForSelect() zeigt bei Änderungen der Formulardaten die TID anstelle des Namens an
    const ds: any = { ...row };
    Object.keys(ds).forEach((k: string) => {
        if (ds[`${k}_display`]) {
            ds[k] = ds[`${k}_display`];
        }
    });

    let info = '';
    if (entity === IDs.ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN_TECHNIK) {
        info += ds.name ? `${ds.name} | ` : '';
        if (ds.energietraeger_art === 'strom') {
            info += 'Strom';
        } else if (ds.energietraeger_art === 'weitere' && ds.energietraeger_tid) {
            info += ds.energietraeger_tid;
        } else if (ds.energietraeger_art === 'kraftstoffe' && ds.energietraeger_tid2) {
            info += ds.energietraeger_tid2;
        }
        return (info || '').trim().replace(/\ \|$/, '');
    }
    if (entity === IDs.ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN_RAEUMLICHKEITEN) {
        info += ds.flaeche_gesamt + 'm² | ';
        info += ds.vermietungstage + 'd | ';
        info += ds.nutzungszeit + 'h/d';
        return ds.bemerkung || info;
    }
    if ([IDs.ENT_ANABREISE, IDs.ENT_CO2_SCOPE3_EMITTENTEN, IDs.ENT_CO2_SCOPE3_PENDELN_KAMPAGNE, IDs.ENT_VSME_B4].indexOf(entity) !== -1) {
        info += ds.name ? `${ds.name} | ` : '';
    }
    if ([IDs.ENT_CO2_SCOPE3_REISEN].indexOf(entity) !== -1) {
        if (ds.modus === 'user_specific') {
            info += ds.name_nutzer ? `${ds.name_nutzer}: ` : '';
            info += ds.menge_nutzer ? `${ds.menge_nutzer}${ds.einheit_nutzer ? ` ${ds.einheit_nutzer}` : ''} | ` : '';
        }
        info += ds.titel ? `${ds.titel} | ` : '';
    }
    // indexOf() === false ergibt immer false !
    // if (entity !== IDs.ENT_CO2_SCOPE3_REISEN && (ds.name || '').indexOf('Unbekannt') === false) {
    //     info += ds.name ? `${ds.name} | ` : '';
    // }
    if ([IDs.ENT_CO2_SCOPE3_PENDELN, IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT].indexOf(entity) !== -1) {
        if (ds.modus === 'user_specific') {
            info += ds.name_nutzer ? `${ds.name_nutzer}: ` : '';
            info += ds.menge_nutzer ? `${ds.menge_nutzer}${ds.einheit_nutzer ? ` ${ds.einheit_nutzer}` : ''} | ` : '';
        }
    }
    if (entity === IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT) {
        if (ds.modus === 'user_specific') {
            info += ds.name_nutzer ? `${ds.name_nutzer}: ` : '';
            info += ds.menge_nutzer ? `${ds.menge_nutzer}${ds.einheit_nutzer ? ` ${ds.einheit_nutzer}` : ''} | ` : '';
        } else {
            const option = ds.art ? getStaticOption(IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT, 'art', ds.art) : null;
            info += option ? `${option}: ` : '';
        }
    }
    if (entity === IDs.ENT_ANGEMIETETE_RAEUMLICHKEITEN) {
        const option = ds.nutzungsart ? getStaticOption(IDs.ENT_ANGEMIETETE_RAEUMLICHKEITEN, 'nutzungsart', ds.nutzungsart) : null;
        info += option ? `${option} | ` : '';
    }
    if (entity === IDs.ENT_ANGEMIETETE_FAHRZEUGE) {
        const option = ds.transportmittel ? getStaticOption(IDs.ENT_ANGEMIETETE_FAHRZEUGE, 'transportmittel', ds.transportmittel) : null;
        info += option ? `${option} | ` : '';
    }
    if (entity === IDs.ENT_EIGENE_RAEUMLICHKEITEN) {
        const option = ds.nutzungsart ? getStaticOption(IDs.ENT_EIGENE_RAEUMLICHKEITEN, 'nutzungsart', ds.nutzungsart) : null;
        info += option ? `${option} | ` : '';
    }
    if (ds.abrechnungszeitraum_von && ds.abrechnungszeitraum_bis) {
        info += `${Moment(ds.abrechnungszeitraum_von * 1000).format('DD.MM.YYYY')} - ${Moment(ds.abrechnungszeitraum_bis * 1000).format('DD.MM.YYYY')} | `;
    }
    info += ds.stromanbieter ? `${ds.stromanbieter} | ` : '';
    info += ds.zaehler_tid ? `${ds.zaehler_tid} | ` : '';
    if (entity !== IDs.ENT_CO2_SCOPE3_REISEN
        || (entity === IDs.ENT_CO2_SCOPE3_REISEN && ds.firmenfahrzeug_orig !== 1 && ds.firmenfahrzeug !== 'Ja' && ds.firmenfahrzeug !== 1)
    ) {
        info += ds.energietraeger_tid ? `${ds.energietraeger_tid} | ` : '';
    }
    info += ds.anlagen_eigenstrom_typ_tid ? `${ds.anlagen_eigenstrom_typ_tid} | ` : '';
    // console.log(ds.art_tid, bundle.art_tid);
    if (ds.art_tid && bundle && Array.isArray(bundle.art_tid)) {
        const art: string = (bundle.art_tid.find((item: any) => item.tid === ds.art_tid) || {}).name || null;
        info += (art || ds.art_tid) ? `${(art || ds.art_tid)} ` : '';
    }
    info += ds.mitarbeiter ? `${ds.mitarbeiter} | ` : '';
    info += ds.lieferant ? `${ds.lieferant} | ` : '';
    info += ds.lieferant_tid ? `${ds.lieferant_tid} | ` : '';
    info += ds.fahrzeug_tid ? `${ds.fahrzeug_tid} | ` : '';
    info += ds.entfernung ? `${ds.entfernung} km | ` : '';
    if (ds.kategorie) {
        let found = false;
        const formItem = formConfig.items.find((item: any) => item.key === 'kategorie');
        if (formItem.options) {
            const opt = formItem.options.find((o: any) => o.tid === ds.kategorie);
            if (opt) {
                found = true;
                info += opt.name ? `${opt.name} | ` : '';
            }
        }
        if (!found) {
            info += ds.kategorie ? `${ds.kategorie} | ` : '';
        }
        // console.log('DS KAT', info, ds, formConfig);

        // console.log(formConfig);
    }
    info += ds.bemerkung ? `${ds.bemerkung} | ` : '';
    if (entity === IDs.ENT_CO2_SCOPE3_REISEN) {
        if (ds.firmenfahrzeug_orig === 1 || ds.firmenfahrzeug === 'Ja' || ds.firmenfahrzeug === 1) {
            info += 'Firmenfahrzeug | ';
        }
        if (ds.reiseland) {
            let rl = ds.reiseland;
            const struct = new StructureTool(IDs.MOD_ETOOL).getStructure(IDs.MOD_ETOOL, IDs.ENT_CO2_SCOPE3_REISEN);
            if (struct) {
                const atts = struct.ATTS;
                (atts || []).forEach((a: any) => {
                    if (a.KEY === 'reiseland') {
                        const opts = a.OPTS;
                        opts.forEach((o: any) => {
                            if (o.VALUE === ds.reiseland) {
                                rl = o.TITEL;
                            }
                        });
                    }
                });
            }
            // console.log('DS', struct);
            // info += `${(art || ds.art_tid)} `;
            info += rl ? `${rl} | ` : '';
        }
        info += ds.teilnehmer > 0 ? `${ds.teilnehmer} Teiln. | ` : '';
        info += ds.uebernachtungen_anzahl ? `${ds.uebernachtungen_anzahl} ÜN | ` : '';
    }
    if (entity === IDs.ENT_CO2_SCOPE3_GUETER_KAPITAL || entity === IDs.ENT_CO2_SCOPE3_GUETER_EINKAUF) {
        info += ds.name ? `(${ds.name}) | ` : (ds.art_tid ? ' | ' : '');
    }
    if (entity === IDs.ENT_ENERGIEDATEN_STROM) {
        const group: any[] = (list || [])
            .filter((item: any) =>
                (item.abrechnungszeitraum_von || null) === (ds.abrechnungszeitraum_von || null)
                && (item.abrechnungszeitraum_bis || null) === (ds.abrechnungszeitraum_bis || null)
                && (item.zaehler_tid || null) === (ds.zaehler_tid || null)
            )
            .map((item2: any) => item2.tid);
        info += group.length > 1 ? ` (${group.indexOf(ds.tid) + 1}) ` : '';
    }
    if (entity === IDs.ENT_STANDORT) {
        info = [
            ds.standort_typ_tid || '', ds.name,
            `${ds.strasse || ds.hausnummer ? `${ds.ort || ''},${ds.strasse ? ` ${ds.strasse}` : ''}${ds.hausnummer ? ` ${ds.hausnummer}` : ''}` : ds.ort || ''}`
        ].join(' ');
    }
    const res = (info || '').trim().replace(/\ \|$/, '');

    return res || 'Unspezifizierter Datensatz';
}
